export default __webpack_public_path__ + "e112617b69022f15f1a75876ddd3316b.svg";